import {product} from "./features/product.ts";
import {gallery} from "./features/gallery.ts";
import {stays} from "./features/stays.ts";


export default () => {
  product()
  gallery()
  stays()
}
